import { Navigate } from 'react-router-dom';
import { useAuth } from '@repletoryreach/sdk-auth';
import { LoadingOverlay } from '@repletoryreach/sdk-ui/feedback';
import type { ReactElement, ReactNode } from 'react';
import { useT } from '../../i18n/I18nProvider';

/** Gate for the auth pages: a signed-in tenant user is bounced to the app. */
export function RequireUnauthed({ children }: { children: ReactNode }): ReactElement {
  const { user, loading } = useAuth();
  const t = useT();

  if (loading) {
    return (
      <div className="rr-page-loading">
        <LoadingOverlay visible label={t('shell.loading')} />
      </div>
    );
  }

  if (user && user.scope === 'tenant') return <Navigate to="/" replace />;
  return <>{children}</>;
}
